import { AskResponse, Citation } from "@/api/models";
import { cloneDeep } from "lodash-es";

type ParsedAnswer = {
  citations: Citation[];
  markdownFormatText: string;
};

export function parseAnswer(answer: AskResponse): ParsedAnswer {
  let answerText = answer.answer;
  let exportText = answer.answer;
  const citationLinks = answerText.match(/\[(doc\d+(?:\s*,\s*doc\d+)*)\]/g);
  const urlLinks = answerText.match(/【\d+:\d+†source】/g);

  let filteredCitations = [] as Citation[];
  let citationReindex = 0;

  // Document citations
  citationLinks?.forEach(link => {
    const citationLabels = link.slice(1, -1).split(/\s*,\s*/);
    const inlineCitations: string[] = [];
    const exportCitations: string[] = [];

    citationLabels.forEach(label => {
      // Replacing the links/citations with number
      const citationIndex = label.slice("doc".length);
      const citation = cloneDeep(answer.citations[Number(citationIndex) - 1]) as Citation;
      if (citation === undefined) return;

      citationReindex += 1;
      inlineCitations.push(`[CITATION_${citationReindex}](https://custom-sms-gpt-citation/${citationReindex})`);
      filteredCitations.push(citation);

      // Format response for export
      exportCitations.push(`[${citationReindex}]`);
      if (!answer.export_citations?.find((c) => c.id === citationReindex)) answer.export_citations = [...(answer.export_citations || []), { id: citationReindex, title: citation.title }];
    });

    answerText = answerText.replaceAll(link, inlineCitations.join(" "));
    exportText = exportText.replaceAll(link, exportCitations.join(" "));
  });

  // URL citations
  urlLinks?.forEach((link, idx) => {
    // Replacing the links/citations with number
    let citationIndex = idx + 1;
    let citation = cloneDeep(answer.citations[citationIndex-1]) as Citation;
    if (citation !== undefined && !filteredCitations.find((c) => c.text === link)) {
      answerText = answerText.replaceAll(link, `[CITATION_${citationIndex}](https://custom-sms-gpt-citation/${citationIndex})`);
      filteredCitations.push(citation);
      
      // Format response for export
      exportText = exportText.replaceAll(link, `[${citationIndex}]`);
      if (exportText.includes(`[${citationIndex}]`) && !answer.export_citations?.find((c) => c.id === citationIndex)) answer.export_citations = [...(answer.export_citations || []), { id: citationIndex, title: citation.url_citation?.url }];
    }
  });

  // Set formatted text for export
  answer.export_text = exportText;

  return {
    citations: filteredCitations,
    markdownFormatText: answerText
  };
}
